import React, { useState, useEffect } from "react";
import ActivityDisplay from "./ActivityDisplay";
import { useListDevicesQuery } from "../../actions/devicesInQuery";
import { useDetectionsAlerts } from "../../hooks/useAppAlerts";
import { Flex } from "antd";
import "./index.css";

type Props = {};

const Index: React.FC<Props> = () => {
  const { data: devices, isLoading: devicesLoading } = useListDevicesQuery();
  const [onlineDevices, setOnlineDevices] = useState(0);
  const comingSoon = true;

  useEffect(() => {
    const onlineCount =
      devices?.items?.filter((d) => d.status === "online").length || 0;
    setOnlineDevices(onlineCount);
  }, [devices]);

  const { data: detectionData, isLoading: isDetectionLoading } =
    useDetectionsAlerts({ tags: ["Detection"], skip: comingSoon });

  const totalMosquitoDetections = detectionData?.count || 0;

  const { data: invasiveAlertsData, isLoading: isInvasiveAlertsLoading } =
    useDetectionsAlerts({ tags: ["Invasive"], skip: comingSoon });

  const totalInvasiveMosquitoDetections = invasiveAlertsData?.count || 0;

  return (
    <Flex gap="1.5rem" className="w-full">
      <Flex flex={1}>
        <ActivityDisplay
          label="Invasive mosquito"
          sublabel="detections alerts"
          variant="primary"
          value={totalInvasiveMosquitoDetections}
          loading={isInvasiveAlertsLoading}
          comingSoon
        />
      </Flex>
      <Flex flex={1}>
        <ActivityDisplay
          label="Total mosquito"
          sublabel="detections alerts"
          variant="primary"
          value={totalMosquitoDetections}
          loading={isDetectionLoading}
          comingSoon
        />
      </Flex>
      <Flex flex={1}>
        <ActivityDisplay
          label="Traps online "
          sublabel={`(of ${devices?.items?.length || 0})`}
          variant="primary"
          value={onlineDevices}
          loading={devicesLoading}
        />
      </Flex>
    </Flex>
  );
};

export default Index;
